"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "bg-mutedpurple-800 zigzag-bottom zigzag-mutedpurple-800 pt-24 pb-20 min-h-[480px] flex justify-center px-5" };
const _hoisted_2 = { class: "w-full max-w-screen-xl" };
const _hoisted_3 = { class: "uppercase text-3xl sm:text-6xl text-yellow-500 leading-squished tracking-tighter font-black mb-10" };
const _hoisted_4 = ["href"];
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Free Spanish Test", -1);
const vue_3 = require("vue");
const BodyText_vue_1 = __importDefault(require("../BodyText.vue"));
const ListingsFilter_vue_1 = __importDefault(require("./ListingsFilter.vue"));
const ListingsList_vue_1 = __importDefault(require("./ListingsList.vue"));
const Listings_1 = require("../../stores/Listings");
const pinia_1 = require("pinia");
const ButtonIcon_vue_1 = __importDefault(require("../ButtonIcon.vue"));
const Route_1 = __importDefault(require("../../src/Route"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ListingsIndex',
    setup(__props) {
        const store = (0, Listings_1.useListingsStore)();
        const { category, level, type, tag } = (0, pinia_1.storeToRefs)(store);
        const urlParams = new URLSearchParams(window.location.search);
        category.value = urlParams.get('category') || null;
        level.value = urlParams.get('level') || null;
        type.value = urlParams.get('type') || null;
        tag.value = urlParams.get('tag') || null;
        (0, vue_3.watch)(category, updateUrl);
        (0, vue_3.watch)(level, updateUrl);
        (0, vue_3.watch)(type, updateUrl);
        (0, vue_3.watch)(tag, updateUrl);
        function updateUrl() {
            const url = new URL(window.location.href);
            if (category.value) {
                url.searchParams.set('category', category.value);
            }
            else {
                url.searchParams.delete('category');
            }
            if (level.value) {
                url.searchParams.set('level', level.value);
            }
            else {
                url.searchParams.delete('level');
            }
            if (type.value) {
                url.searchParams.set('type', type.value);
            }
            else {
                url.searchParams.delete('type');
            }
            if (tag.value) {
                url.searchParams.set('tag', tag.value);
            }
            else {
                url.searchParams.delete('tag');
            }
            window.history.replaceState({
                type: type.value,
                category: category.value,
                level: level.value,
                tag: tag.value,
            }, window.document.title, url);
        }
        const introTitle = (0, vue_3.computed)(() => {
            switch (type.value) {
                case 'course':
                    return 'Courses';
                case 'event':
                    return 'Events';
                default:
                    return 'What’s on';
            }
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("header", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createElementVNode)("h1", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(introTitle)), 1),
                        ((0, vue_2.unref)(type) === 'course')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                (0, vue_2.createVNode)(BodyText_vue_1.default, {
                                    class: "text-white",
                                    cols: 1
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.renderSlot)(_ctx.$slots, "courses_description")
                                    ]),
                                    _: 3
                                }),
                                (0, vue_2.createElementVNode)("a", {
                                    href: (0, vue_2.unref)(Route_1.default)('proficiency-tests.current'),
                                    class: "button button-outlined button-coral-500 hover:button-coral-600 no-underline w-full sm:w-auto mt-5 text-white"
                                }, [
                                    (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                                    _hoisted_5
                                ], 8, _hoisted_4)
                            ], 64))
                            : ((0, vue_2.unref)(type) === 'event')
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(BodyText_vue_1.default, {
                                    key: 1,
                                    class: "text-white",
                                    cols: 1
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.renderSlot)(_ctx.$slots, "events_description")
                                    ]),
                                    _: 3
                                }))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(BodyText_vue_1.default, {
                                    key: 2,
                                    class: "text-white",
                                    cols: 1
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.renderSlot)(_ctx.$slots, "whatson_description")
                                    ]),
                                    _: 3
                                }))
                    ])
                ]),
                (0, vue_2.createVNode)(ListingsFilter_vue_1.default),
                (0, vue_2.createVNode)(ListingsList_vue_1.default)
            ], 64));
        };
    }
});
